import { ButtonHTMLAttributes, ReactNode, useState } from 'react';
import { Popover } from '@mantine/core';
import { usePortalTarget } from '../../provider/UiContext';
import { DTB_POPUP_Z } from '../popupZIndex';

interface IDataTableExportMenuProps {
    /** Вид и подпись кнопки выгрузки туллбара */
    buttonProps: ButtonHTMLAttributes<HTMLButtonElement>;
    icon: ReactNode;
    exportAllLabel: string;
    exportSelectedLabel: string;
    selectedCount: number;
    onExport: (onlySelected: boolean) => void;
}

/** Меню выгрузки «всё / выбранные» со своим состоянием: открытие не перерисовывает таблицу. */
const DataTableExportMenu = ({
    buttonProps,
    icon,
    exportAllLabel,
    exportSelectedLabel,
    selectedCount,
    onExport,
}: IDataTableExportMenuProps) => {
    const portalTarget = usePortalTarget();
    const [opened, setOpened] = useState(false);
    const exportRows = (onlySelected: boolean) => {
        setOpened(false);
        onExport(onlySelected);
    };
    return (
        <Popover
            opened={opened}
            onChange={setOpened}
            position="bottom-end"
            withinPortal
            portalProps={portalTarget ? { target: portalTarget } : undefined}
            shadow="md"
            radius={12}
            zIndex={DTB_POPUP_Z}
        >
            <Popover.Target>
                <button {...buttonProps} onClick={() => setOpened((open) => !open)}>
                    {icon}
                </button>
            </Popover.Target>
            <Popover.Dropdown p={4}>
                <div className="dtb-ctx">
                    <button type="button" className="dtb-ctx__item" onClick={() => exportRows(false)}>
                        {exportAllLabel}
                    </button>
                    <button
                        type="button"
                        className="dtb-ctx__item"
                        disabled={selectedCount === 0}
                        onClick={() => exportRows(true)}
                    >
                        {exportSelectedLabel}
                    </button>
                </div>
            </Popover.Dropdown>
        </Popover>
    );
};

export default DataTableExportMenu;
